import React from 'react'
import Header from '../../components/common/Header'
import Footer from '../../components/common/Footer'
import Update from '../../components/System/Update'
import { useUpdateApi } from '../../hooks/useUpdate'

const UpdatePage = () => {
  const {mutate, isLoading} = useUpdateApi()
  const handleSubmit = () => {
    mutate()
  }

  return (
    <>
        <Header />
        <Update
          handleSubmit={handleSubmit}
          isUpdating={isLoading}
        />
        <Footer />
    </>
  )
}

export default UpdatePage